import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';

import SubMenuItem from '@/ui/chrome/menu/SubMenuItem.vue';
import IconFlagService from '@/core/flagicon.service';
import { QueryParams } from '@/core/query-params.service';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelectorModal',
  props: {
    languageNavigationItems: null,
    openState: { type: Boolean }
  },
  emits: ["closeLanguageSelector"],
  setup(__props: any, { emit }: { emit: ({(e: 'closeLanguageSelector'): void}), expose: any, slots: any, attrs: any }) {




const selectedMode = computed<IMode>(() => store.getters['app/selectedMode']);
const router = useRouter();

function isCurrentPage(menuItem: INavigationViewObject): boolean {
    // this will ignore any query string parameters
    return router.currentRoute.path === menuItem.path;
}

function buildLanguageUrl(lang: any) {
    return `/${lang.code.toLowerCase()}/${selectedMode.value.name}?${QueryParams.DualLanguageSignal}`;
}

function getFlag(lang: any): string {
    const splitCode = lang.code.toLowerCase().split('-');
    const countryCode = splitCode.length > 1 ? splitCode[1] : '';
    return IconFlagService.getFlagHtml(countryCode);
}

function closeLanguageSelector(): void {
    emit('closeLanguageSelector');
}


return { __sfc: true,emit, selectedMode, router, isCurrentPage, buildLanguageUrl, getFlag, closeLanguageSelector, SubMenuItem }
}

})